import React from 'react';

export default class LoadMoreButton extends React.Component {
  constructor(props) {
    super(props);
    this.page = parseInt(props.page);
    this.url = this.props.url;
    this.$itemsContainer = $(props.containerSelector);
    this.state = {};
  }

  urlWithPage() {
    return URI(this.url).setQuery('page', this.page);
  }

  loadNextPage = () => {
    this.page += 1;
    var self = this;

    $.get(this.urlWithPage(), function(data) {
      $(data).appendTo(self.$itemsContainer);
    });
  }

  render() {
    return(
      <a className="btn btn-primary"
         onClick={this.loadNextPage}>
        {this.props.text}
      </a>
    )
  }
}




// WEBPACK FOOTER //
// ./app/javascript/components/load_more_button.jsx